<template>
  <div id="Specification">
    <Head />
    <div class="Specification clear">
      <Nav ms="/Specification" />
      <div class="H-right">
        <div class="title">单位统计指标</div>
        <div class="t_main">
          <div class="f_title">财务指标列表</div>
          <el-table
            border
            :header-cell-style="{
              'background-color': '#001743',
              color: '#fff',
              height: '0.5rem',
            }"
            :data="tableData"
            style="width:12rem"
            :row-style="{ height: '0.4rem' }"
          >
            <el-table-column
              label="序号"
              header-align="center"
              align="center"
              width="100"
              type="index"
            ></el-table-column>
            <el-table-column
              prop="Year"
              label="数据年份"
              header-align="center"
              align="center"
              width="300"
            ></el-table-column>
            <el-table-column
              prop="Status"
              label="填写状态"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">{{
                scope.row.Status == 0
                  ? "未填写"
                  : scope.row.Status == 2
                  ? "已退回"
                  : "已上报"
              }}</template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  style="background: #F3252F;color:#ffffff;"
                  @click="Del(scope.row)"
                  >{{
                    scope.row.Status == 0
                      ? "填写"
                      : scope.row.Status == 2
                      ? "填写"
                      : "查看"
                  }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            style="text-align: right;height: 0.45rem;"
            v-if="tableData1.length>0"
            @current-change="CurrentChange1"
            @size-change="handleSizeChange1"
            :current-page="Page1"
            :page-size="PageSize1"
            :page-sizes="[10, 20, 30]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="total1"
          ></el-pagination>-->
        </div>
        <div class="t_main" v-if="userinfo.Property != 10">
          <div class="f_title">专业指标列表</div>
          <el-table
            border
            :header-cell-style="{
              'background-color': '#001743',
              color: '#fff',
              height: '0.5rem',
            }"
            :data="tableData1"
            style="width:12rem"
            :row-style="{ height: '0.4rem' }"
          >
            <el-table-column
              label="序号"
              header-align="center"
              align="center"
              width="100"
              type="index"
            ></el-table-column>
            <el-table-column
              prop="Year"
              label="数据年份"
              header-align="center"
              align="center"
              width="300"
            ></el-table-column>
            <el-table-column
              prop="Status"
              label="填写状态"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">{{
                scope.row.Status == 0
                  ? "未填写"
                  : scope.row.Status == 2
                  ? "已退回"
                  : "已上报"
              }}</template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  style="background: #F3252F;color:#ffffff;"
                  @click="Del1(scope.row)"
                  >{{
                    scope.row.Status == 0
                      ? "填写"
                      : scope.row.Status == 2
                      ? "填写"
                      : "查看"
                  }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            style="text-align: right;height: 0.45rem;"
            v-if="tableData1.length>0"
            @current-change="CurrentChange1"
            @size-change="handleSizeChange1"
            :current-page="Page1"
            :page-size="PageSize1"
            :page-sizes="[10, 20, 30]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="total1"
          ></el-pagination>-->
        </div>
        <div class="t_write" v-if="show">
          <div class="write">
            <p>{{ yearstr + "财务统计指标" }}</p>
            <i class="cancel" @click="cancel"></i>
            <div class="info">
              <div
                v-for="(item, index) in name"
                :key="index"
                :ref="'changetext' + index"
              >
                <span>{{ item.Name }}</span>
                <input
                  v-model="content[index].value"
                  type="text"
                  v-if="Status == 0 || Status == 2"
                />
                <div class="readonly" :title="content[index].value" v-else>
                  {{ content[index].value | sLen }}
                </div>
              </div>
            </div>
            <div class="info" v-if="Status == 0 || Status == 2">
              <div class="btn" @click="save(content)">保存</div>
              <div class="btn btn_mr" @click="updata(content)">上报</div>
            </div>
          </div>
        </div>
        <div class="t_write" v-if="show1">
          <div class="write">
            <p>{{ yearstr + "专业统计指标" }}</p>
            <i class="cancel" @click="cancel1"></i>
            <div class="info">
              <div
                v-for="(item, index) in name1"
                :key="index"
                :ref="'changetext' + index"
              >
                <span>{{ item.Name }}</span>
                <input
                  v-model="content1[index].value"
                  type="text"
                  v-if="Status == 0 || Status == 2"
                />
                <div class="readonly" :title="content1[index].value" v-else>
                  {{ content1[index].value | sLen }}
                </div>
              </div>
            </div>
            <div class="info" v-if="Status == 0 || Status == 2">
              <div class="btn" @click="save(content1)">保存</div>
              <div class="btn btn_mr" @click="updata(content1)">上报</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
export default {
  data() {
    return {
      tableData: [],
      tableData1: [],
      name: [],
      name1: [],
      content: [],
      content1: [],
      yearstr: "",
      //write:['1、营业收入','2、利润总额','3、净利润','4、资产总额','5、负债总额','6、所有者权益总额','7、海外收入','8、海外资产','9、纳税总额','10、研发费用','11、从业人员','12、从业人员人均年收入','13、安全生产费用'],
      // type1:['1、营业收入','2、利润总额','3、净利润','4、资产总额','5、负债总额','6、所有者权益总额','7、海外收入','8、海外资产','9、纳税总额','10、研发费用','11、从业人员','12、从业人员人均年收入','13、安全生产费用'],
      userinfo: {},
      show: false,
      show1: false,
      Status: "",
      msg: "",
    };
  },
  inject: ["reload"],
  mounted() {},
  created() {
    this.getdata();
    let that = this;
    if (sessionStorage.getItem("userinfo")) {
      var id = JSON.parse(sessionStorage.getItem("userinfo")).ID;
      console.log(id);
      // console.log(this.userinfo);
      this.$axios
        .post(
          "company/info",
          that.$qs.stringify({
            ID: id,
            token: sessionStorage.getItem("token"),
          })
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == 10000) {
            this.userinfo = res.data.data;
          } else {
            that.$message(res.data.msg);
          }
        });
    }
  },
  filters: {
    sLen(val) {
      if (val.length > 15) {
        val = val.slice(0, 12) + "...";
      }
      return val;
    },
  },
  methods: {
    // reg(str,i){
    //   str = str.replace('#', "%23").replace('+', "%2b").replace('$', "%24").replace(/\+/g, "%5e").replace(/\+/g, "%26").replace(/\+/g, "%2a").replace(/\+/g, "%3d")
    //   console.log(str,i)
    //   this.content[i].value=str
    //   console.log(this.content[i].value)
    // },
    updata(i) {
      var that = this;
      that.save(i);
      that.$axios
        .post(
          "Statistic/upStatus?Status=1&ID=" +
            that.StatisticID +
            "&token=" +
            sessionStorage.getItem("token")
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.$message({
              type: "info",
              message: "已成功上报",
            });
          } else {
            this.$message({
              type: "info",
              message: "上报失败",
            });
          }
        });
      this.show = false;
      this.show1 = false;
    },
    save(a) {
      var that = this;
      console.log(a);
      for (var i = 0; i < a.length; i++) {
        a[i]["value"] = a[i]["value"]
          .replace("#", "%23")
          .replace("+", "%2b")
          .replace("$", "%24")
          .replace("^", "%5e")
          .replace("&", "%26")
          .replace("*", "%2a")
          .replace("=", "%3d")
          .replace("(", "%28")
          .replace(")", "%29");
        that.$axios
          .post(
            "/StatisticContent/add",
            that.$qs.stringify({
              Title: a[i]["Title"],
              Content: a[i]["value"],
              StatisticID: that.StatisticID,
              token: sessionStorage.getItem("token"),
            })
            // that.$URL +
            //   "/StatisticContent/add?Title=" +
            //   a[i]["Title"] +
            //   "&Content=" +
            //   a[i]["value"] +
            //   "&StatisticID=" +
            //   that.StatisticID +
            //   "&token=" +
            //   sessionStorage.getItem("token")
          )
          .then((res) => {
            this.msg = res.data.msg;
          });
      }
      console.log(this.msg, 111);
      this.$message({
        type: "info",
        message: "已保存",
      });
      this.reload();
      this.show = false;
      this.show1 = false;
    },
    getdata() {
      var that = this;
      that.$axios
        .post(
          "Statistic/SelectStatic?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            //:this.restatus
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.tableData = res.data.data.list;
            this.tableData1 = res.data.data.list1;
            this.name = res.data.data.name;
            // console.log(this.name)
            this.name1 = res.data.data.name1;
            console.log(res.data.data, 111);
            //this.total = res.data.data.total_num;
            this.content = [];
            this.content1 = [];

            for (var i = 0; i < this.name.length; i++) {
              var item = {
                Name: this.name[i]["Name"],
                value: "",
                Title: this.name[i]["Code"],
              };
              this.content.push(item);
              // console.log(this.content);
            }
            //this.content1.splice(0);

            for (var j = 0; j < this.name1.length; j++) {
              var item1 = {
                Name: this.name1[j]["Name"],
                value: "",
                Title: this.name1[j]["Code"],
              };
              console.log(this.name1[j]["Name"]);
              this.content1.push(item1);
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },

    flexColumnWidth(str) {
      let flexWidth = 0;
      for (const char of str) {
        if ((char >= "A" && char <= "Z") || (char >= "a" && char <= "z")) {
          // 如果是英文字符，为字符分配8个单位宽度
          flexWidth += 8;
        } else if (char >= "\u4e00" && char <= "\u9fa5") {
          // 如果是中文字符，为字符分配20个单位宽度
          flexWidth += 20;
        } else {
          // 其他种类字符，为字符分配5个单位宽度
          flexWidth += 5;
        }
      }
      if (flexWidth < 50) {
        // 设置最小宽度
        flexWidth = 200;
      }
      if (flexWidth > 250) {
        // 设置最大宽度
        flexWidth = 250;
      }
      return flexWidth + "px";
    },
    Del(a) {
      this.StatisticID = a.ID;
      console.log(this.StatisticID, 666);
      let that = this;
      that.$axios
        .post(
          "StatisticContent/index?StatisticID=" +
            that.StatisticID +
            "&token=" +
            sessionStorage.getItem("token")
        )
        .then((res) => {
          console.log(res.data, 2232);
          //  console.log(res.data.data.list,66666)
          if (res.data.code == 10000) {
            if (res.data.data.list.length == 0) {
              for (var i1 = 0; i1 < this.content.length; i1++) {
                this.content[i1]["value"] = "";
                // console.log(this.content,1333);
              }
            } else {
              for (var i = 0; i < res.data.data.list.length; i++) {
                this.content[i]["value"] = res.data.data.list[i]["Content"];
                // console.log(this.content,1333);
              }
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
      this.show = true;
      this.Status = a.Status;
      this.yearstr = a.Year;
    },
    Del1(a) {
      this.show1 = true;
      this.Status = a.Status;
      this.yearstr = a.Year;
      this.StatisticID = a.ID;
      let that = this;
      that.$axios
        .post(
          "StatisticContent/index?StatisticID=" +
            that.StatisticID +
            "&token=" +
            sessionStorage.getItem("token")
        )
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data);
            if (res.data.data.list.length == 0) {
              for (var j1 = 0; j1 < this.content1.length; j1++) {
                this.content1[j1]["value"] = "";
                // console.log(this.content,1333);
              }
            } else {
              for (var j = 0; j < res.data.data.list.length; j++) {
                // console.log(this.content1[j]["value"])
                this.content1[j]["value"] = res.data.data.list[j]["Content"];
                // console.log(this.content,1333);
              }
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    cancel() {
      this.show = false;
    },
    cancel1() {
      this.show1 = false;
    },
  },
  components: {
    Head,
    Foot,
    Nav,
  },
};
</script>

<style lang="less" scoped>
.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.btn {
  width: 1rem;
  cursor: pointer;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.17rem;
  text-align: center;
  background: #409eff;
  border-radius: 0.04rem;
  color: #fff;
}

.Specification {
  width: 100%;
  min-width: 1000px;
  font-size: 0.16rem;
  padding: 0.28rem 2.54rem;
  box-sizing: border-box;

  .H-right {
    position: relative;
    width: 11.5rem;
    min-width: 750px;
    padding-left: 0.2rem;
    height: 100%;
    float: right;
    min-height: 9.4rem;
    border-left: 1px #eeeeee solid;
    position: relative;

    .title {
      font-size: 0.4rem;
      margin: 0.2rem 0 0.5rem;
      text-align: center;
    }
  }

  .t_main {
    margin-bottom: 0.4rem;

    .f_title {
      margin-bottom: 0.2rem;
      color: #1c1c1c;
      font-size: 0.2rem;
      font-weight: 700;
    }
  }

  .t_write {
    background: rgba(10, 10, 10, 0.3);
    padding: 0.77rem 0.7rem;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10000;

    .write {
      background: #fff;
      padding: 0.3rem 0.45rem;
      position: relative;

      p {
        font-size: 0.3rem;
        color: #0d0d0d;
        text-align: center;
        margin-bottom: 0.52rem;
      }

      .cancel {
        width: 0.25rem;
        height: 0.25rem;
        display: block;
        background: url("../../assets/back/x.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 0.3rem;
        top: 0.3rem;
      }

      .info {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .readonly {
          max-width: 2rem;
          height: 0.35rem;
          border: 0.01rem solid #ccc;
          margin: 0;
          line-height: 0.35rem;
          padding-left: 0.1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          box-shadow: 0 2px 12px -2px rgba(0, 0, 0, 0.1);
        }

        div {
          width: 43%;
          margin-bottom: 0.46rem;
          display: flex;
          align-items: center;

          span {
            display: inline-block;
            margin-right: 0.1rem;
            // width: 1.05rem;
            width: 2.25rem;
            text-align: right;
          }

          input {
            width: 2rem;
            height: 0.35rem;
            margin-right: 0.1rem;
          }
        }
      }

      .btn {
        cursor: pointer;
        margin-top: 0.4rem;
        width: 1.5rem;
        height: 0.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        background: #2d65d2;
        float: right;
      }

      > .btn_mr {
        margin-right: 0.2rem;
      }
    }
  }
}
</style>
